<template>
  <NavBar :custom-back="customLeft" />
  <div class="error-wrap">
    <div class="error-pond">
      <img class="error-img" src="~~/assets/imgs/error/error_req_fail.png" alt="加载失败" />
      <p class="error-tips">{{ $t('page_error') }}</p>
    </div>
    <client-only>
      <van-button plain @click="reload">{{ $t('base_retry') }}</van-button>
    </client-only>
  </div>
</template>

<script setup lang="ts">
import NavBar from '~~/components/nav/NavBar.vue'

const { $bt } = useNuxtApp()

const customLeft = () => $bt.call.close()

function reload() {
  console.log('重载')
}
</script>

<style scoped lang="less">
.error-wrap {
  text-align: center;
  overflow: hidden;
  .van-button {
    margin: 24px auto 0;
    padding: 0 15px;
    color: @Text50;
    min-width: 95px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    border: 2px solid @Black03;
    border-radius: 4px;
  }
}
.error-pond {
  margin-top: 125px;
  overflow: hidden;

  .error-img {
    margin: 20px auto 0;
    width: 180px;
    height: 180px;
  }

  .error-tips {
    margin: 12px 60px 0;
    font-size: 14px;
    color: @Text40;
    line-height: 21px;
    text-align: center;
  }
}
</style>
